const colors = [
    {front: 'red', back: 'darkred'},
    {front: 'green', back: 'darkgreen'},
    {front: 'blue', back: 'darkblue'},
    {front: 'yellow', back: 'darkyellow'},
    {front: 'orange', back: 'darkorange'},
    {front: 'pink', back: 'darkpink'},
    {front: 'purple', back: 'darkpurple'},
    {front: 'turquoise', back: 'darkturquoise'}
];


const randomRange = (min, max) => Math.random() * (max - min) + min;

export class Confetti {

    confettiCount = 300;
    gravity = 0.5;
    terminalVelocity = 5;
    drag = 0.075;
    confetti = [];

    constructor(canvas) {
        this.canvas = canvas;
        this.render();
    }

    start({x, y, x0, x1, y0, y1, vx0 = -25, vx1 = 25, vy0 = 0, vy1 = -50}) {
        for (let i = 0; i < this.confettiCount; i++) {
            this.confetti.push({
                color: colors[Math.floor(randomRange(0, colors.length))],
                dimensions: {
                    x: randomRange(10, 20),
                    y: randomRange(10, 30),
                },
                position: {
                    x: (x || x === 0 ? x : randomRange(x0 || 0, x1 || this.canvas.width)),
                    y: (y || y === 0 ? y : (y0 && y1 ? randomRange(y0, y1) : this.canvas.height - 1)),
                },
                rotation: randomRange(0, 2 * Math.PI),
                scale: {
                    x: 1,
                    y: 1,
                },
                velocity: {
                    x: randomRange(vx0, vx1),
                    y: randomRange(vy0, vy1),
                }
            });
        }
    }

    render() {
        const ctx = this.canvas.getContext("2d");
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.confetti.forEach((confetto, index) => {
            let width = confetto.dimensions.x * confetto.scale.x;
            let height = confetto.dimensions.y * confetto.scale.y;

            // Move canvas to position and rotate
            ctx.translate(confetto.position.x, confetto.position.y);
            ctx.rotate(confetto.rotation);

            // Apply forces to velocity
            confetto.velocity.x -= confetto.velocity.x * this.drag;
            confetto.velocity.y = Math.min(confetto.velocity.y + this.gravity, this.terminalVelocity);
            confetto.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random();

            // Set position
            confetto.position.x += confetto.velocity.x;
            confetto.position.y += confetto.velocity.y;

            // Delete confetti when out of frame
            if (confetto.position.y >= this.canvas.height) {
                this.confetti.splice(index, 1);
            }

            // Loop confetto x position
            if (confetto.position.x > this.canvas.width) {
                confetto.position.x = 0;
            }

            if (confetto.position.x < 0) {
                confetto.position.x = this.canvas.width;
            }

            // Spin confetto by scaling y
            confetto.scale.y = Math.cos(confetto.position.y * 0.1);
            ctx.fillStyle = confetto.scale.y > 0 ? confetto.color.front : confetto.color.back;

            // Draw confetto
            ctx.fillRect(-width / 2, -height / 2, width, height);

            // Reset transform matrix
            ctx.setTransform(1, 0, 0, 1, 0, 0);
        });

        window.requestAnimationFrame(() => this.render());
    }

}
